import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Modal, message } from 'antd';
import { signOut } from 'firebase/auth';
import { auth } from '../../../firebaseConfig';
import './SideNav.less';

const { confirm } = Modal;

const SideNav = () => {
    const navigate = useNavigate();

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            message.success("Signed out successfully");
            navigate('/'); // Redirect to home page after sign-out
        } catch (error) {
            console.error("Error signing out: ", error);
            message.error("Error signing out!");
        }
    };

    const showConfirm = () => {
        confirm({
            title: 'Are you sure you want to sign out?',
            content: 'You will be redirected to the home page.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleSignOut();
            },
            onCancel() {
                console.log('Cancel sign out');
            },
        });
    };

    return (
        <div className="sidenav">
            <div className="sidenav-links">
                <NavLink to="https://www.forestbirdnest.com" className="sidenav-link">Home</NavLink>
                <NavLink to="/admin/items" className="sidenav-link">Items List</NavLink>
                {/* <NavLink to="/admin/configurations" className="sidenav-link">Configurations List</NavLink> */}
                <NavLink to="/admin/banners" className="sidenav-link">Banner List</NavLink>
            </div>
            <div className="sidenav-footer">
                <div className="sidenav-link" onClick={showConfirm}>Sign Out</div>
            </div>
        </div>
    );
};

export default SideNav;
